module.exports = __webpack_public_path__ + "static/media/main_image_4.84024096.jpg";